import "./layout.scss";
import { useState } from "react";
import { Flex, Layout, Modal } from "antd";
import MenuFM from "./menu";
import images from "../../assets/imgs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { COOKIE_AUTH_TOKEN, ENV_STAGING } from "../../constants/common";
import { AuthServices } from "../../services/auth";
import { useAuth } from "../../context/AuthContext";
import { APP_VERSION } from "../../constants/version";
import { ENV } from "../../constants/env";
const { Header, Content } = Layout;

interface LayoutFMProps {
  children?: React.ReactNode;
}

const LayoutFM: React.FC<LayoutFMProps> = ({ children }) => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {user} = useAuth();
  const {firstName, lastName, roles = [] } = user || {};

  const handleLogout = async () => {
    setIsLoading(true)
    try {
      const res: any = await AuthServices.logOut();
      if (res?.success) {
        setIsModalOpen(false);
        Cookies.remove(COOKIE_AUTH_TOKEN);
        navigate("/login");
      }
    } catch {} finally {setIsLoading(false)}
  };

  const showModalLogout = () => {
    setIsModalOpen(true);
  };

  const handleCancelLogout = () => {
    setIsModalOpen(false);
  };

  const renderModalLogout = () => (
    <Modal
      title="Confirm Logout"
      closable={{ "aria-label": "Custom Close Button" }}
      open={isModalOpen}
      onOk={handleLogout}
      onCancel={handleCancelLogout}
      okText="Logout"
      confirmLoading={isLoading}
    >
      <p style={{fontSize: "20px"}}>Are you sure you want to log out of the system?</p>
    </Modal>
  );
  return (
    <Layout className="layout">
      <Header className={`header ${ENV.env === ENV_STAGING ? "header-staging" : ""}`}>
        <Flex align="center" gap={50}>
          <div className="logo">
            <img alt="logo" src={images.logo} />
          </div>
          <MenuFM />
        </Flex>

        <Flex align="center" gap={10}>
          <span className="box-name">
            <div>{`${firstName} ${lastName}`}</div>
            <div className="small">{roles[0]?.name}</div>
            <div className="version">Version: {APP_VERSION}</div>
          </span>
          <FontAwesomeIcon icon={faArrowRightFromBracket} className="logout" onClick={showModalLogout} />
        </Flex>
      </Header>
      <Content className={`main-content ${ENV.env === ENV_STAGING ? "main-content-staging" : ""}`}>
        {children}
      </Content>
      {renderModalLogout()}
    </Layout>
  );
};

export default LayoutFM;
